import { render, staticRenderFns } from "./AddSmaManualPayment.vue?vue&type=template&id=0857afff"
import script from "./AddSmaManualPayment.vue?vue&type=script&lang=js"
export * from "./AddSmaManualPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports